import AppBar from '../components/AppBar'
import Toolbar from '../components/Toolbar'

const AppAppBar = () => {
  return (
    <AppBar position="static" color="transparent" sx={{ padding: 1 }}>
      <Toolbar sx={{ justifyContent: 'flex-end' }}>
        {/* <img
          src={MeetParker}
          width="83"
          height="auto"
          alt="MeetParker"
        /> */}
        {/* <img
          src="https://meetparker.co.uk/wp-content/uploads/2021/01/logo-without-text.png"
          width={80}
          height={80}
        /> */}
        {/* <a
          href="https://www2.deloitte.com/us/en.html"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={DeloitteLogo}
            height="35"
            width="auto"
            alt="Deloitte"
            style={{ marginRight: '20px' }}
          />
        </a>
        <a href="https://spf.co.uk/" target="_blank" rel="noreferrer">
          <img
            src={SPFLogo}
            height="100"
            width="auto"
            alt="SPF Private Clients"
          />
        </a> */}
      </Toolbar>
    </AppBar>
  )
}

export default AppAppBar
